module.exports = __webpack_public_path__ + "static/img/smartstation13.8eff4dfd.png";